@if ((knowledgeSources?.length ?? 0) === 0 && (knowledgeBases?.length ?? 0) === 0) {
  <div class="empty-state-inline">
    <mat-icon>storage</mat-icon>
    <span>{{ 'EDIT_KNOWLEDGE.NO_KNOWLEDGE' | translate }}</span>
  </div>
} @else {
<mat-list>
  @for (source of knowledgeSources; track source) {
    <mat-list-item lines="3" class="knowledge-source-list">
      <mat-icon class="knowledge-icon" matListItemIcon>{{ getKnowledgeSourceIcon(source) }}</mat-icon>
      <!-- Note: matListItemLine doesn't apply properly if these lines are in a container, so each line has a condition...-->
      <div matListItemLine class="knowledge-source-title">
        @if (editingEnabled) {
          <a class="knowledge-source-title-link" (click)="clickTitle(source)">{{ source.name }}</a>
        } @else {
          <span>{{ source.name }}</span>
        }
          @if (source.config?.websiteScrapeConfig?.options?.automaticRefreshTime) {
            <mat-icon [glxyTooltip]="
                'WEBSITE_SCRAPE.AUTOMATIC_RESCRAPE_ENABLED'
                  | translate
                    : {
                        date: $safeNavigationMigration(source?.config?.websiteScrapeConfig?.refreshScheduledFor) | date,
                      }
              " inline="true" color="primary">update
          </mat-icon>
        }
        @if (!isTrainingInfoFinished(source.training)) {
          <mat-icon [glxyTooltip]="'EDIT_KNOWLEDGE.TRAINING.TRAINING_IN_PROGRESS_TOOLTIP' | translate" inline="true"
            color="primary">fitness_center
          </mat-icon>
        }
      @if (source.isSuggested) {
        <glxy-badge [size]="'small'">Suggested</glxy-badge>
      }
    </div>
    <!-- Website Config Lines-->
    @if (source?.config?.websiteScrapeConfig) {
      <div class="preview" matListItemLine>
        <span>{{ getKnowledgePreview(source) }}</span>
      </div>
    }
    <ai-knowledge-last-scraped [knowledgeSource]="source" [allowRescrapeWebsite]="this.allowRescrapeWebsite"
      (rescrapeInitiated)="rescrapeInitiated($event)"
    (refreshSource)="refreshList.emit()"></ai-knowledge-last-scraped>
    <!-- Non-Website Config Lines-->
    @if (!source?.config?.websiteScrapeConfig) {
      <span class="preview">{{ getKnowledgePreview(source) }}</span>
    }
    @if (canRemoveSource(source) && editingEnabled) {
      <div matListItemMeta>
        <div>
          <mat-icon class="clickable" (click)="clickRemove(source)">close</mat-icon>
        </div>
      </div>
    }
  </mat-list-item>
  <mat-divider class="break-out-mat-card-content"></mat-divider>
}
@for (kb of knowledgeBases; track kb.id) {
  <mat-list-item lines="3" class="knowledge-source-list">
    <mat-icon class="knowledge-icon" matListItemIcon>library_books</mat-icon>
    <div matListItemLine class="knowledge-source-title">
      @if (knowledgeBaseDetailRoute(kb); as detailRoute) {
        <a
          class="knowledge-source-title-link"
          [routerLink]="detailRoute"
          [queryParams]="knowledgeBaseDetailQueryParams(kb)"
          >{{ kb.name }}</a
        >
      } @else {
        <span class="knowledge-source-title-link">{{ kb.name }}</span>
      }
    </div>
    @if (kb.description) {
      <span class="preview">{{ kb.description }}</span>
    }
    @if (editingEnabled) {
      <div matListItemMeta>
        <div>
          <mat-icon class="clickable" (click)="clickRemoveKnowledgeBase(kb)">close</mat-icon>
        </div>
      </div>
    }
  </mat-list-item>
  <mat-divider class="break-out-mat-card-content"></mat-divider>
}
</mat-list>
}
